import angular from 'angular';

//v2 Imports
import gbGenericHeader from './components/gbGenericHeader';
import gbThemedHeading from './components/gbThemedHeading';
import gbThemedBtnCards from './components/gbThemedBtnCards';
import alternatingCircText from './components/alternatingCircText';
import gbCopyright from './components/gbCopyright';
import directory from './components/directory';
import portalHeader from './components/portalHeader';
import textPost from './components/textPost';
import socialMedia from './components/socialMedia';
import headerFaderBars from './components/arribas/headerFaderBars';
import compHeaderCenter from './components/arribas/compHeaderCenter';
import banner from './components/banner';
import floatingTabs from './components/floatingTabs';
import singleLogo from './components/singleLogo';
import interval from './components/interval';
import genericSponsorPortal from './components/genericSponsorPortal';



// Directives
import causeEvents from './directives/causeEvents';
import defaultSponsorLogo from './directives/defaultSponsorLogo';
import slickSlider from './directives/slickSlider';
import templateDelegater from './directives/templateDelegater';

const causePortalModule = angular.module('com.module.cause-portal', []);


// v2 components
causePortalModule.component('gbGenericHeader', gbGenericHeader);
causePortalModule.component('gbThemedHeading', gbThemedHeading);
causePortalModule.component('gbThemedBtnCards', gbThemedBtnCards);
causePortalModule.component('alternatingCircText', alternatingCircText);
causePortalModule.component('gbCopyright', gbCopyright);
causePortalModule.component('directory', directory);
causePortalModule.component('portalHeader', portalHeader);
causePortalModule.component('textPost', textPost);
causePortalModule.component('socialMedia', socialMedia);
causePortalModule.component('compHeaderCenter', compHeaderCenter);
causePortalModule.component('headerFaderBars', headerFaderBars);
causePortalModule.component('banner', banner);
causePortalModule.component('floatingTabs', floatingTabs);
causePortalModule.component('singleLogo', singleLogo);
causePortalModule.component('interval', interval);
causePortalModule.component('genericSponsorPortal', genericSponsorPortal);


// Directives
causePortalModule.directive('causeEvents', causeEvents);
causePortalModule.directive('defaultSponsorLogo', defaultSponsorLogo);
causePortalModule.directive('slickSlider', slickSlider);
causePortalModule.directive('templateDelegater', templateDelegater);

export default causePortalModule;



// WEBPACK FOOTER //
// ./js/containers/causePortal/index.js